/**
 * CARD_CATALOG: the authoritative list of capability cards for the
 * `capability-cards` CMS block.
 *
 * featureKey: null   → always available (no feature flag gates it)
 * featureKey: string → requires that ecosystem capability to be enabled
 *
 * Adding a new card here is the only code change needed. No CMS config
 * or data migration required.
 */
const CARD_CATALOG = [
    {
        id: 'directory',
        featureKey: null,
        icon: '🏢',
        heading: 'Explore Organizations',
        description:
            'Browse organizations in the ecosystem — spanning education, industry, nonprofits, and government.',
        ctaLabel: 'Browse Ecosystem',
        ctaPath: '/directory',
    },
    {
        id: 'mentoring',
        featureKey: 'mentoring',
        icon: '🧑‍🏫',
        heading: 'Find Mentors',
        description:
            'Connect with mentors, collaborators, and peers across the ecosystem who share your interests and goals.',
        ctaLabel: 'Browse Mentors',
        ctaPath: '/connections/mentors',
    },
    {
        id: 'opportunities',
        featureKey: 'opportunities',
        icon: '🔍',
        heading: 'Discover Opportunities',
        description:
            'Browse internships, workshops, grants, and more across the ecosystem.',
        ctaLabel: 'Explore Opportunities',
        ctaPath: '/opportunities',
    },
    {
        id: 'aiAssistant',
        featureKey: 'aiAssistant',
        icon: '🧭',
        heading: 'Navigate with AI',
        description:
            'Use our AI assistant to find organizations, mentors, and opportunities tailored to your needs.',
        ctaLabel: 'Ask Assistant',
        ctaPath: '/assistant',
    },
    {
        id: 'ecosystemAnalytics',
        featureKey: 'ecosystemAnalytics',
        icon: '📊',
        heading: 'Insights',
        description:
            'Explore analytics, sector distribution, and collaboration patterns across the ecosystem.',
        ctaLabel: 'View Insights',
        ctaPath: '/ecosystem',
    },
    {
        id: 'discoverPartners',
        featureKey: 'discoverPartners',
        icon: '🤝',
        heading: 'Find Partners',
        description:
            'Discover organizations looking to collaborate across sectors and build new connections.',
        ctaLabel: 'Browse Partners',
        ctaPath: '/connections/partners',
    },
    {
        id: 'networkGraph',
        featureKey: 'networkGraph',
        icon: '🕸️',
        heading: 'Explore the Network',
        description:
            'Visualize how organizations across the ecosystem are connected to one another.',
        ctaLabel: 'View Network',
        ctaPath: '/directory?view=graph',
    },
];

export default CARD_CATALOG;
